export const parseEntries = (value) => {
  if (!value || typeof value !== 'string') return [];
  return value
    .split(/\n\s*\n/)
    .map((entry) => entry.trim())
    .filter(Boolean);
};
